import Content from '@layout/Content'
import TwoWaySlabForm from './TwoWaySlabForm'
import TwoWaySlabResult from './TwoWaySlabResult'
import { TwoWaySlabProvider } from './context'

function TwoWaySlabPage () {
  return (
    <TwoWaySlabProvider>
      <Content
        renderInput={<TwoWaySlabForm />}
        renderOutput={<TwoWaySlabResult />}
      />
    </TwoWaySlabProvider>
  )
}

export default TwoWaySlabPage
